import { JSONSchemaType } from "ajv"
import validateConstant, {
  e入力パターン,
} from "../../../constant/validateConstant"
import util from "../../../ts/util"
import {
  TSiharaisakiRegisterPostReq,
  TSiharaisakiUpdatePutReq,
} from "./TSiharaisaki"

export const TSiharaisakiRegisterPostReqSchema: JSONSchemaType<TSiharaisakiRegisterPostReq> =
  {
    type: "object",
    properties: {
      支払先コード: {
        minLength: 1,
        type: "string",
        maxLength: validateConstant.LENGTH.支払先コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "支払先コード",
        errorMessage: util.stringErrorMessage("支払先コード", {
          required: true,
          maxLength: validateConstant.LENGTH.支払先コード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
      支払先区分コード: {
        type: "string",
        title: "支払先区分コード",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        errorMessage: util.stringErrorMessage("支払先区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      支払先名: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "支払先名",
        errorMessage: util.stringErrorMessage("支払先名", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      支払先略称: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般カナ名称,
        title: "支払先略称",
        nullable: true,
        errorMessage: util.stringErrorMessage("支払先略称", {
          required: false,
          maxLength: validateConstant.LENGTH.一般カナ名称,
        }),
      },
      郵便番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.郵便番号,
        title: "郵便番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("郵便番号", {
          required: false,
          maxLength: validateConstant.LENGTH.郵便番号,
        }),
      },
      住所１: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所１,
        title: "住所",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所", {
          required: false,
          maxLength: validateConstant.LENGTH.住所１,
        }),
      },
      住所２: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所２,
        title: "住所",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所", {
          required: false,
          maxLength: validateConstant.LENGTH.住所２,
        }),
      },
      住所３: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所３,
        title: "住所",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所", {
          required: false,
          maxLength: validateConstant.LENGTH.住所３,
        }),
      },
      電話番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        title: "電話番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("電話番号", {
          required: false,
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      FAX番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        title: "FAX番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("FAX番号", {
          required: false,
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      支払先担当者: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般名称,
        title: "備考",
        nullable: true,
        errorMessage: util.stringErrorMessage("支払先担当者", {
          required: false,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      インボイス登録番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.インボイス登録番号,
        title: "インボイス登録番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("インボイス登録番号", {
          required: false,
          maxLength: validateConstant.LENGTH.インボイス登録番号,
        }),
      },
    },
    required: ["支払先コード", "支払先区分コード", "支払先名"],
  }
export const TSiharaisakiUpdatePutReqSchema: JSONSchemaType<TSiharaisakiUpdatePutReq> =
  {
    type: "object",
    properties: {
      支払先コード: {
        minLength: 1,
        type: "string",
        maxLength: validateConstant.LENGTH.支払先コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "支払先コード",
        errorMessage: util.stringErrorMessage("支払先コード", {
          required: true,
          maxLength: validateConstant.LENGTH.支払先コード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
      支払先区分コード: {
        type: "string",
        title: "支払先区分コード",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        errorMessage: util.stringErrorMessage("支払先区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      支払先名: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "支払先名",
        errorMessage: util.stringErrorMessage("支払先名", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      支払先略称: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般カナ名称,
        title: "支払先略称",
        nullable: true,
        errorMessage: util.stringErrorMessage("支払先略称", {
          required: false,
          maxLength: validateConstant.LENGTH.一般カナ名称,
        }),
      },
      郵便番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.郵便番号,
        title: "郵便番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("郵便番号", {
          required: false,
          maxLength: validateConstant.LENGTH.郵便番号,
        }),
      },
      住所１: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所１,
        title: "住所",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所", {
          required: false,
          maxLength: validateConstant.LENGTH.住所１,
        }),
      },
      住所２: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所２,
        title: "住所",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所", {
          required: false,
          maxLength: validateConstant.LENGTH.住所２,
        }),
      },
      住所３: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所３,
        title: "住所",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所", {
          required: false,
          maxLength: validateConstant.LENGTH.住所３,
        }),
      },
      電話番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        title: "電話番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("電話番号", {
          required: false,
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      FAX番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        title: "FAX番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("FAX番号", {
          required: false,
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      支払先担当者: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般名称,
        title: "備考",
        nullable: true,
        errorMessage: util.stringErrorMessage("支払先担当者", {
          required: false,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      インボイス登録番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.インボイス登録番号,
        title: "インボイス登録番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("インボイス登録番号", {
          required: false,
          maxLength: validateConstant.LENGTH.インボイス登録番号,
        }),
      },
      更新日時: {
        type: "string",
        minLength: 1,
        title: "更新日時",
        errorMessage: util.stringErrorMessage("更新日時", {
          required: true,
        }),
      },
    },
    required: ["支払先コード", "支払先区分コード", "支払先名"],
  }
